const GetQuestion = (id: string) => {
    switch (id) {
        case 'cm_p2_p1': return '¿Ha sido diagnosticado, padecido o tratado medicamente por alguna enfermedad o accidente durante los últimos 5 años?*';
        case 'cm_p2_p2': return '¿Durante los últimos 3 años ha consultado algun médico para ser examinado, operado, tratado o aconsejado?*';
        case 'cm_p2_p3': return '¿Ha estado en tratamiento o le han diagnosticado diabetes, azúcar en la orina, enfermedades del riñón, fiebre reumática, desordenes cardíacos, presión alta, enfermedades de pulmón, úlcera, hepatitis B, desordenes del aparato digestivo, epilepsia, desordenes nerviosos, mentales o circulatorios?*';
        case 'cm_p2_p4': return '¿Tiene alguno de estos síntomas sin explicación? Fatiga, Pérdida de peso, diarrea, ganglios linfáticos inflamados o extrañas lesiones en la piel?*';
        case 'cm_p2_p5': return '¿Ha sido tratado o diagnosticado de algún desorden o enfermedad relacionada con alcohol, drogas, Síndrome de imunodeficiencia adquirida (SIDA), Complejo relacionado al SIDA (ARC) o condiciones relacionadas con el SIDA? ¿Padece alguna limitación física, malformación o amputación?*';
        case 'cm_p3_p1': return '¿Se encuentra de subsidio médico o está en algún proceso de ser declarado con algún tipo de incapacidad o invalidez?*';
        case 'cm_p3_p2': return '¿Alguna vez ha solicitado seguro de vida, accidentes, salud, o rehabilitación que haya sido declinada, rechazada o recargada? *';
        case 'cm_p3_p3': return '¿Tiene otros seguros de vida?*';
        case 'cm_p3_p4': return 'Practica automovilismo en carreras de velocidad y resistencia, motociclismo, motocross, cacería, charrería, ciclismo profesional, deportes náuticos, esqui, hockey, luchador, jockey, parapente, planeador, vuelo delta, salto en bungee, aviación militar, acróbata bombero, buzo, dinamitero, domador de animales salvajes, corridas de toros en las barreras, guardaespaldas, marinero de submarino, minero, pescador, policía, torero, fútbol o beisbol de manera profesional, esqui acuático, polo, pesca a más de 5 km de la costa, rodeo, rugby o boxeo.*';
        case 'cm_p3_p5': return '¿Se encuentra embarazada o padece de alguna enfermedad de ovarios, matriz o mamas?*';
        case 'er_p4_p1': return 'Tos seca';
        case 'er_p4_p2': return 'Secreción nasal';
        case 'er_p4_p3': return 'Malestar general';
        case 'er_p4_p4': return 'Fiebre ';
        case 'er_p4_p5': return 'Dificultad respiratoria';
        case 'er_p4_p6': return 'Dolor de garganta';
        case 'er_p4_p7': return 'Diarrea';
        case 'er_p4_p8': return 'Falta de aire';
        case 'er_p4_p9': return 'Pérdida del gusto';
        case 'er_p4_p10': return 'Pérdida del olfato';
        case 'er_p4_p11': return 'Brote en la piel, manos o piernas';
        case 'er_p5_p1': return 'Enfermedades crónicas del corazón';
        case 'er_p5_p2': return 'Enfermedades pulmonares';
        case 'er_p5_p3': return 'Recibe tratamientos inmunosupresores';
        case 'er_p5_p4': return 'Cáncer';
        case 'er_p5_p5': return 'Diabetes';
        case 'er_p5_p6': return 'Hipertensión arterial ';
        case 'er_p5_p7': return '¿Algún médico le ha prescrito realizarse prueba COVID?*';
        case 'er_p5_p8': return '¿Ha sido hospitalizado por enfermedades respiratorias?*';
        case 'er_p5_p9': return '¿Está usted vacunado contra COVID-19?*';
        case 'er_p5_p10': return '¿Ha viajado durante los últimos 14 días?*';
        case 'cm_p3_p2_1': return '¿Hace cuánto?*';
        /*preguntas adicionales*/
        case 'cm_p2_p1_1': return 'Favor detallar el motivo (rutina o padecimiento):*';
        case 'cm_p2_p2_1': return 'Favor detallar el motivo (rutina o padecimiento):*';
        case 'cm_p3_p2_2': return '¿Con qué compañía de seguros?*';
        case 'cm_p3_p3_1': return '¿Con qué compañía de seguros? *';
        case 'cm_p3_p4_1': return '¿Qué deporte practica?*';
        case 'cm_p3_p4_2': return '¿Hace cuánto tiempo?*';
        case 'cm_p3_p5_1': return '¿Cuál es su padecimiento?*';
        case 'cm_p3_p5_2': return '¿Hace cuánto lo padece?*';
        case 'cm_p3_p5_3': return '¿Qué tratamiento toma?*';
        case 'er_p5_p7_1': return '¿Cuál fue el motivo?';
        case 'er_p5_p10_1': return '¿Qué país visitó?*';

        /*datos laborales*/

        case 'dp_p1_p1_1a': return '¿Tu contrato es Temporal?';
        case 'dp_p1_p1_2a': return '¿Cuando vence tu contrato?';
        case 'dp_p1_p1_3a': return 'País de la empresa en que labora';
        case 'dp_p1_p1_1b': return '¿Es una empresa familiar?';
        case 'dp_p1_p1_2b': return 'Indique el giro del negocio';

        case 'dp_p1_p1': return '¿Trabaja usted por cuenta propia?';
        case 'dp_p1_p2': return 'Horas trabajadas a la semana*';
        case 'dp_p1_p3': return '¿Cotizas INSS?';


        default: return '';
    }

}

const typeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    /*  { value: '3', text: 'Residencia' }, */
];

const sex = [
    { value: '1', text: 'Masculino' },
    { value: '2', text: 'Femenino' }
];


export { GetQuestion, typeDocument, sex }